import { axiosInstance } from "src/axios-instance";

const orders = "/orders";
const OrdersServices = {
  getOrderaByStatus: (status, branch_id) =>
    axiosInstance.post(`${orders}/status/${status}`, { branch_id }),
  updateOrderStatus: (data) =>
    axiosInstance.post(`${orders}/update-order-status/${data.order_id}`, data),
  getOrder: (id) => axiosInstance.get(`${orders}/show/${id}`),
  refundOrder: (id, amount) => axiosInstance.post(`/ngenius/orders/${id}/refund`,{
    amount: parseFloat(amount),
  }),
};

export default OrdersServices;
